








































import Vue from 'vue';
import { urlFor } from '@/config/sanity';

export enum EmployeePortraitSize {
  Default = 'default',
  Small = 'small'
}

export default Vue.extend({
  name: 'EmployeePortrait',
  props: {
    name: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    department: {
      type: String,
      required: false,
    },
    size: {
      type: String,
      required: false,
      default: () => EmployeePortraitSize.Default.toString(),
      validator: (value: string) => [
        EmployeePortraitSize.Default.toString(),
        EmployeePortraitSize.Small.toString(),
      ].indexOf(value) !== -1,
    },
  },
  methods: {
    urlFor,
  },
});
